import { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { useQueryParams } from "hooks/app-router"
import { useTasksFiltersFormik } from "./use-tasks-filters-formik"

export function useTasksFiltersQueryParams() {
  const history = useHistory()
  const params = useQueryParams<{
    name?: string
    state?: "active" | "archived"
    billable?: "true" | "false" | undefined
    tags?: string
    section_status?: "active" | "archived"
    groups?: string
    users?: string
  }>()

  const formik = useTasksFiltersFormik()

  function update(values: typeof formik.values) {
    const { name, state, billable, tags, section_status, users, groups } =
      values

    const params = new URLSearchParams()
    name && params.append("name", name)
    state !== "active" &&
      state &&
      params.append("state", state as "active" | "archived" | "all")
    billable !== undefined &&
      params.append("billable", billable ? "true" : "false")
    tags && tags.length > 0 && params.append("tags", JSON.stringify(tags))
    section_status !== "active" &&
      section_status &&
      params.append("section_status", section_status)
    groups &&
      groups?.length > 0 &&
      params.append("groups", JSON.stringify(groups))
    users && users?.length > 0 && params.append("users", JSON.stringify(users))

    history.push(`?${params}`)
  }

  const [nameFilter, setNameFilter] = useState<string>()
  const [stateFilter, setStateFilter] = useState<
    "active" | "archived" | "all"
  >()
  const [billableFilter, setBillableFilter] = useState<
    "true" | "false" | undefined
  >(undefined)
  const [membersGroupHashIds, setMembersGroupHashIds] = useState<
    string[] | undefined
  >([])
  const [usersAccountHashIds, setUsersAccountHashIds] = useState<
    string[] | undefined
  >([])
  const [sectionStatusFilter, setSectionStatusFilter] = useState<
    "active" | "archived" | "all"
  >()
  const [tagsFilter, setTagsFilter] = useState<string[] | undefined>([])

  useEffect(() => {
    setNameFilter(params.name)
    setStateFilter(params.state)
    setBillableFilter(!params.billable ? undefined : params.billable)
    setTagsFilter(params.tags ? JSON.parse(params.tags) : undefined)
    setSectionStatusFilter(params.section_status)
    setMembersGroupHashIds(
      params.groups ? JSON.parse(params.groups) : undefined
    )
    setUsersAccountHashIds(params.users ? JSON.parse(params.users) : undefined)
  }, [history.location.search])

  return {
    nameFilter,
    stateFilter,
    billableFilter,
    membersGroupHashIds,
    usersAccountHashIds,
    sectionStatusFilter,
    tagsFilter,
    update,
  }
}
